/** Admin audio library routes (see puzzle-be/docs/audio-rest-api.md). */
export const ADMIN_AUDIO_LIST_PATH = "/admin/audio";
export const ADMIN_AUDIO_NEW_PATH = "/admin/audio/new";

export function adminAudioEditPath(id) {
    return `/admin/audio/edit/${id}`;
}
